import ReactDOM from 'react-dom/client';
import { EPAGE } from './types';
import App from './App';

import './index.scss';
import './scss/fancybox.scss';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App page={EPAGE.INDEX} />); // index.html
//root.render(<App page={EPAGE.ERROR} />); // error.html
//root.render(<App page={EPAGE.PAGE_404} />); // 404.html
//root.render(<App page={EPAGE.PAGE_50X} />); // 50x.html
